export const populatePrepaymentByDebtorType = (
  getValue: (field: string) => any,
  setFieldValue: (field: string, value: any) => void,
  debtorType: string
) => {
  if (debtorType === 'orderer') {
    const orderer = getValue('orderer')
    const personCustomer = orderer?.personCustomer
    const companyCustomer = orderer?.companyCustomer
    if (personCustomer) {
      setFieldValue('prepaymentPaymentDetails.debtorName', `${personCustomer.firstName} ${personCustomer.lastName}`.trim())
      setFieldValue('prepaymentPaymentDetails.receiptEmail', personCustomer.email ?? '')
      setFieldValue('prepaymentPaymentDetails.debtorPhone', personCustomer.phone ?? '')
    } else if (companyCustomer) {
      setFieldValue('prepaymentPaymentDetails.debtorName', companyCustomer.companyName ?? '')
      setFieldValue('prepaymentPaymentDetails.receiptEmail', companyCustomer.contactPersonEmail ?? '')
      setFieldValue('prepaymentPaymentDetails.debtorPhone', companyCustomer.phone ?? '')
    }
  } else if (debtorType === 'holder') {
    setFieldValue('prepaymentPaymentDetails.debtorName', getValue('vehicleDetails.holder') ?? '')
  } else if (debtorType === 'owner') {
    setFieldValue('prepaymentPaymentDetails.debtorName', getValue('vehicleDetails.owner') ?? '')
  } else if (debtorType === 'other') {
    setFieldValue('prepaymentPaymentDetails.debtorName', '')
  }
}
